export default __webpack_public_path__ + "static/media/holding-hands.73ba8290.jpg";